import { Injectable } from '@angular/core';

import { Injector } from '@angular/core';
import { Observable, interval, of } from 'rxjs';
import { HttpService, autoSubscribe, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { Vendor } from './vendor';
import { Material } from './material';
import { MaterialsResponcePage } from './materials-response-page';
import { MaterialPage } from './materials-page';
import { MaterialUnit } from './material-unit';
import { MaterialType } from './material-type';
import { SearchBody } from 'projects/app-misc/src/app/modules/search/data/searchBody';
import { ShortObject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-json-object';



@Injectable({
    providedIn: 'root',
})
export class MaterialsService extends HttpService {

    constructor(
        protected injector: Injector) {
        super(injector);
    }

    getMaterials(start: number, rows: number): Observable<MaterialsResponcePage> {
        return this.getData(`/cv/materials?start=${start}&limit=${rows}`, MaterialsResponcePage);
    }

  createMaterial(material): Observable<MaterialPage> {
    return this.postData(`/cv/materials/create`, material, MaterialPage);
  }

  deleteMaterial(materialId): Observable<MaterialPage> {
    return this.deleteData(`/cv/materials/${materialId}`, MaterialPage);
  }

    getCustomMaterials(start: number, limit: number, query?: string, vendors?: number[], types?: number[]): Observable<MaterialsResponcePage> {
        if (query || (vendors && vendors.length > 0) || (types && types.length > 0)) {
            return this.postData(`/cv/materials/search`, {
                start,
                limit,
                query,
                vendors,
                types
            } as any, MaterialsResponcePage);
        }
        else {
            return this.getData(`/cv/materials?start=${start}&limit=${limit}`, MaterialsResponcePage);
        }
    }

    searchShortMaterialsForOrders(start: number, limit: number, query: string): Observable<ShortObject[]> {
        return this.postData(`/cv/materials/short/search`, {
            start,
            limit,
            query
        } as SearchBody, ShortObject);
    }

    getMaterialTypes(): Observable<MaterialType[]> {
        return this.getData(`/cv/materials/types`, MaterialType);
    }

    getUnits(): Observable<MaterialUnit[]> {
        return this.getData(`/cv/materials/units-of-issue`, MaterialUnit)
    }

    updateMaterial(material: MaterialPage): Observable<MaterialPage> {
        return this.postData(`/cv/materials/single-update`, material, MaterialPage)
    }

}
